import type { ProductCatalogItem } from '@/types/product';

export const mockProducts: ProductCatalogItem[] = [
  { skuId: 'SKU-PV400',  description: 'Panel Solar 400W Monocristalino',  family: 'solar',    unit: 'ud', cycleTimeMin: 18, bomVersion: 'v3.2' },
  { skuId: 'SKU-PV450',  description: 'Panel Solar 450W Bifacial',        family: 'solar',    unit: 'ud', cycleTimeMin: 22, bomVersion: 'v2.1' },
  { skuId: 'SKU-INV5K',  description: 'Inversor String 5kW',              family: 'solar',    unit: 'ud', cycleTimeMin: 35, bomVersion: 'v1.4' },
  { skuId: 'SKU-ELV-M1', description: 'Módulo Elevación 1000kg',          family: 'elevator', unit: 'ud', cycleTimeMin: 90, bomVersion: 'v4.0' },
  { skuId: 'SKU-ELV-M2', description: 'Módulo Elevación 1600kg',          family: 'elevator', unit: 'ud', cycleTimeMin: 120, bomVersion: 'v3.7' },
  { skuId: 'SKU-CAB-A',  description: 'Cabina Estándar Aluminio',         family: 'elevator', unit: 'ud', cycleTimeMin: 75, bomVersion: 'v2.0' },
  { skuId: 'SKU-MISC-1', description: 'Bastidor Universal 600x400',       family: 'misc',     unit: 'ud', cycleTimeMin: 12, bomVersion: 'v1.0' },
  { skuId: 'SKU-MISC-2', description: 'Conector Industrial M16 IP67',     family: 'misc',     unit: 'ud', cycleTimeMin: 4,  bomVersion: 'v1.1' },
];

export function getProduct(skuId: string): ProductCatalogItem | undefined {
  return mockProducts.find((p) => p.skuId === skuId);
}

export function findProductByDescription(query: string): ProductCatalogItem | undefined {
  const q = query.toLowerCase().trim();
  return mockProducts.find((p) => p.description.toLowerCase().includes(q));
}
